import { render, staticRenderFns } from "./IcoFolderMinusBadge.vue?vue&type=template&id=290900bb"
import script from "./IcoFolderMinusBadge.vue?vue&type=script&lang=js"
export * from "./IcoFolderMinusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports